const videosRecommendationsPath =
  "https://leadguitar.s3.eu-north-1.amazonaws.com/videos/recommendations.json";
const homeVideosPath =
  "https://leadguitar.s3.eu-north-1.amazonaws.com/videos/homeVideos.json";
const backendUrl = process.env.REACT_APP_API_BASE_URL;

export const getRecommendations = async () => {
  try {
    const response = await fetch(videosRecommendationsPath, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      const recommendations = await response.json();
      return recommendations;
    } else {
      console.log(
        "Error fetching videos recommendations:",
        response.statusText
      );
      return [];
    }
  } catch (error) {
    console.error("Fetch error:", error);
    return [];
  }
};

export const getHomeVideos = async () => {
  try {
    const response = await fetch(homeVideosPath, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.ok) {
      const homeVideos = await response.json();
      return homeVideos;
    } else {
      console.error("Error fetcing home videos", response.statusText);
      return [];
    }
  } catch (error) {
    console.error("Fetch error:", error);
    return [];
  }
};

export const fetchFormSubmit = async (data) => {
  try {
    const response = await fetch(`${backendUrl}/leads/form`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: data,
    });
    if (response.ok) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error while trying to send data to server", error);
  }
  return false;
};

export const sendFormSubmitMail = async (data) => {
  try {
    await fetch(`${backendUrl}/leads/sendFormSubmitMail`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: data,
    });
  } catch (error) {
    console.error("Error while trying to send email details to server", error);
  }
};
